// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._olmb.MuiPickersDay-root.Mui-selected{background-color:#6942f8;color:#fff}._olmb.MuiPickersDay-root.Mui-selected:hover{background-color:#6942f8}._olmb.MuiPickersDay-root.Mui-disabled:not(.Mui-selected){color:#9393b1;background-color:transparent}._olmb.h3igW:not(.Mui-selected):not(.Mui-disabled){background-color:#e1d9fe}._olmb.h3igW:not(.Mui-selected):not(.Mui-disabled):hover{background-color:#e1d9fe}._olmb.DsJlm:not(.Mui-selected):not(.Mui-disabled):not(.h3igW){color:#6942f8;border:0;font-family:"Lufga-Medium";font-weight:400}._olmb:hover:not(.Mui-selected):not(.Mui-disabled):not(.h3igW){background-color:transparent}._olmb:hover:not(.Mui-disabled){outline:1px solid #6942f8;outline-offset:1px}.itbFM{position:relative;display:inline-flex}.EDBYD{display:flex;flex-direction:column;background:#fff;border-radius:12px;box-shadow:0px 4px 24px rgba(40,40,99,.12);padding:16px;font-family:"Lufga-Medium";font-weight:400}.EDBYD .MuiDayCalendar-weekDayLabel{color:#9393b1;width:40px;font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p2, 12px);line-height:var(--line-height-p2, 16px);letter-spacing:.02em}.EDBYD .MuiPickersDay-root{width:40px;height:40px;color:#282863;font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 14px);line-height:var(--line-height-p1, 22px);letter-spacing:.015em}.EDBYD .MuiDayCalendar-weekContainer{margin:4px 0}.EDBYD .MuiDateCalendar-root{max-height:none;height:auto}._G3Wx{display:flex;align-items:center;justify-content:space-between;padding:8px 4px 16px}.GCJkx{flex:1;text-align:center;color:#282863;font-family:"Lufga-Medium";font-weight:400;font-size:var(--font-size-p1, 14px);line-height:var(--line-height-p1, 22px);letter-spacing:.015em}.TmGrb{display:flex;justify-content:center;padding:8px 0;gap:16px}.QGMbY{display:flex;flex-direction:column}.YkCay{width:100%;box-sizing:border-box;background:#f4f4f7;border:0;border-radius:8px;cursor:pointer;text-align:left}.YkCay[aria-disabled=true]{cursor:default}.YkCay[data-error=true]{outline:1px solid #dd4c4c}.YkCay:focus{outline:none}.YkCay:focus-visible{outline:2px solid #6942f8;outline-offset:2px}.YkCay[data-disabled=true] .QQI2U{color:#bfbfd0}.YkCay[data-error=true] .QQI2U{color:#dd4c4c}.YkCay[data-disabled=true] .ZSvze{color:#bfbfd0}.YkCay[data-error=true] .mfGpQ{color:#dd4c4c}.XCdrz{color:#696992;flex-shrink:0}.YkCay[data-disabled=true] .XCdrz{color:#bfbfd0}.ksBN8{display:inline-flex;align-items:center;gap:8px}.V479C .MuiInputLabel-root{color:#696992;font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 14px);line-height:var(--line-height-p1, 22px);letter-spacing:.015em}.V479C .MuiInputLabel-root.Mui-focused{color:#6942f8}.V479C .MuiInputLabel-root.Mui-disabled{color:#bfbfd0}.V479C .MuiInputLabel-root.Mui-error{color:#dd4c4c}.V479C .MuiOutlinedInput-root{color:#696992;cursor:pointer;font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 14px);line-height:var(--line-height-p1, 22px);letter-spacing:.015em}.V479C .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline{border-color:#282863}.V479C .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline{border-color:#282863;border-width:2px}.V479C .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline{border-color:#6942f8}.V479C .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline{border-color:#dd4c4c}.V479C .MuiOutlinedInput-root.Mui-disabled{color:#bfbfd0;cursor:default}.V479C .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline{border-color:#bfbfd0;border-width:1px}.V479C .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-input{color:#bfbfd0}.V479C .MuiOutlinedInput-input{cursor:pointer;font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p1, 14px);line-height:var(--line-height-p1, 22px);letter-spacing:.015em}.V479C .MuiFormHelperText-root{margin-top:4px;margin-left:0;margin-right:0;font-family:"Lufga-Regular";font-weight:400;font-size:var(--font-size-p2, 12px);line-height:var(--line-height-p2, 16px);letter-spacing:.02em}.V479C .MuiFormHelperText-root.Mui-error{color:#dd4c4c}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blue45": `#fcfcff`,
	"blue48": `#f5f7fd`,
	"blue50": `#f3f5ff`,
	"blue300": `#dae0ff`,
	"blue500": `#c0caff`,
	"blue600": `#a1aef5`,
	"blue700": `#8296ff`,
	"blue800": `#6176e7`,
	"dark50": `#fcfcfd`,
	"dark70": `#f4f4f7`,
	"dark100": `#eaeaef`,
	"dark120": `#e4e4ec`,
	"dark200": `#d4d4e0`,
	"dark300": `#bfbfd0`,
	"dark400": `#a9a9c1`,
	"dark500": `#9393b1`,
	"dark600": `#7e7ea1`,
	"dark700": `#696992`,
	"dark800": `#535382`,
	"dark900": `#282863`,
	"green45": `#eff6fa`,
	"green50": `#f3fcfa`,
	"green300": `#b6ebdf`,
	"green500": `#86ddca`,
	"green700": `#56d0b5`,
	"green800": `#36b89b`,
	"green900": `#089475`,
	"orange50": `#fdf2dc`,
	"orange300": `#fadea8`,
	"orange500": `#f9d797`,
	"orange700": `#f7ca75`,
	"orange800": `#f5bd52`,
	"orange900": `#dd9306`,
	"purple50": `#e1d9fe`,
	"purple300": `#c3b3fc`,
	"purple400": `#b4a1fc`,
	"purple500": `#a58efb`,
	"purple700": `#8768f9`,
	"purple800": `#6942f8`,
	"purple900": `#4520cc`,
	"red200": `#fdf0f0`,
	"red300": `#fee3e3`,
	"red500": `#f9d5d5`,
	"red700": `#f3aaaa`,
	"red900": `#eb7272`,
	"red950": `#e86161`,
	"red970": `#dd4c4c`,
	"white": `#fff`,
	"defaultTextStandard": `#282863`,
	"defaultTextSecondary": `#696992`,
	"defaultButtonPrimary": `#6942f8`,
	"buttonPrimary": `var(--button-primary, #6942f8)`,
	"buttonPrimaryDark": `var(--button-primary-dark, #4520cc)`,
	"buttonDisabled": `var(--button-disabled, #bfbfd0)`,
	"buttonDisabledDark": `var(--button-disabled-dark, #a9a9c1)`,
	"defaultButtonDisabled": `#bfbfd0`,
	"defaultStepperCompleted": `#089475`,
	"defaultStepperIncomplete": `#d4d4e0`,
	"defaultButtonSecondary": `#fcfcfd`,
	"defaultBgStandard": `#f3f5ff`,
	"defaultBgLight": `#fff`,
	"sh10": `0px 4px 12px rgba(40,40,99,.06)`,
	"sh20": `0px 4px 16px rgba(40,40,99,.08)`,
	"sh40": `0px 4px 24px rgba(40,40,99,.12)`,
	"sh60": `0px 4px 14px rgba(40,40,99,.24)`,
	"fontFamilyLight": `"Lufga-Regular"`,
	"fontFamilyNormal": `"Lufga-Medium"`,
	"fontFamilyBold": `"Lufga-SemiBold"`,
	"fontSizeH1": `var(--font-size-h1, 40px)`,
	"fontSizeH2": `var(--font-size-h2, 36px)`,
	"fontSizeH3": `var(--font-size-h3, 28px)`,
	"fontSizeH4": `var(--font-size-h4, 24px)`,
	"fontSizeH5": `var(--font-size-h5, 20px)`,
	"fontSizeH6": `var(--font-size-h6, 18px)`,
	"fontSizeP1": `var(--font-size-p1, 14px)`,
	"fontSizeP2": `var(--font-size-p2, 12px)`,
	"fontSizeP3": `var(--font-size-p3, 10px)`,
	"lineHeightH1": `var(--line-height-h1, 56px)`,
	"lineHeightH2": `var(--line-height-h2, 52px)`,
	"lineHeightH3": `var(--line-height-h3, 36px)`,
	"lineHeightH4": `var(--line-height-h4, 34px)`,
	"lineHeightH5": `var(--line-height-h5, 32px)`,
	"lineHeightH6": `var(--line-height-h6, 30px)`,
	"lineHeightP1": `var(--line-height-p1, 22px)`,
	"lineHeightP2": `var(--line-height-p2, 16px)`,
	"lineHeightP3": `var(--line-height-p3, 14px)`,
	"day": `_olmb`,
	"dayHasEvent": `h3igW`,
	"dayToday": `DsJlm`,
	"dayWrapper": `itbFM`,
	"calendarRoot": `EDBYD`,
	"header": `_G3Wx`,
	"headerLabel": `GCJkx`,
	"actions": `TmGrb`,
	"pickerRoot": `QGMbY`,
	"row": `YkCay`,
	"rowLabel": `QQI2U`,
	"rowValue": `ZSvze`,
	"rowHelperText": `mfGpQ`,
	"rowEditBtn": `XCdrz`,
	"endAdornment": `ksBN8`,
	"textField": `V479C`
};
export default ___CSS_LOADER_EXPORT___;
